<template>
  <div ref="peserta">
    <v-row class="pt-6">
      <v-col cols="12" sm="6" md="3">
        <v-card class="mx-auto" max-width="344" outlined>
          <v-list-item three-line>
            <v-list-item-avatar tile size="80" color="orange"><v-icon size="50" color="white">mdi-file-move-outline</v-icon></v-list-item-avatar>

            <v-list-item-content>
              <div class="text-overline mb-4">
                Diajukan
              </div>
              <v-list-item-title class="text-h6 mb-1">
                {{ stat.total_ajuan }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <v-card class="mx-auto" max-width="344" outlined>
          <v-list-item three-line>
            <v-list-item-avatar tile size="80" color="blue"><v-icon size="50" color="white">mdi-file-lock-outline</v-icon></v-list-item-avatar>

            <v-list-item-content>
              <div class="text-overline mb-4">
                Belum Verval
              </div>
              <v-list-item-title class="text-h6 mb-1">
                {{ stat.belum_diverval }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <v-card class="mx-auto" max-width="344" outlined>
          <v-list-item three-line>
            <v-list-item-avatar tile size="80" color="green"><v-icon size="50" color="white">mdi-file-check-outline</v-icon></v-list-item-avatar>

            <v-list-item-content>
              <div class="text-overline mb-4">
                disetujui
              </div>
              <v-list-item-title class="text-h6 mb-1">
                {{ stat.diterima }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <v-card class="mx-auto" max-width="344" outlined>
          <v-list-item three-line>
            <v-list-item-avatar tile size="80" color="red"><v-icon size="50" color="white">mdi-file-excel-outline</v-icon></v-list-item-avatar>

            <v-list-item-content>
              <div class="text-overline mb-4">
                ditolak
              </div>
              <v-list-item-title class="text-h6 mb-1">
                {{ stat.ditolak }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-card>
      </v-col>
    </v-row>
    <v-alert v-if="queueDoc" border="top" colored-border :type="queueDoc && queueDoc.status == 2 ? 'success' : 'info'" elevation="2" class="my-4">
      <div v-if="queueDoc && (queueDoc.status == 1 || queueDoc.status == 3)">
        <p class="font-weight-bold my-0 py-0">Unduhan Anda dalam proses</p>
        <p class="font-weight-normal my-0 py-0 text-caption">
          Unduhan Anda sedang dalam proses tunggu beberapa saat hingga muncul tautan unduhan.
        </p>
      </div>
      <div v-if="queueDoc && queueDoc.status == 2">
        <p class="font-weight-bold my-0 py-0">Unduhan Anda tersedia</p>
        <p class="font-weight-normal my-0 py-0">
          Unduhan Anda dapat diakses pada tombol berikut
          <m-button
            outlined
            x-small
            class="mx-1"
            color="success"
            :small="$vuetify.breakpoint.smAndDown ? true : false"
            textButton="Unduh"
            icon=""
            action="unduh"
            @unduh="unduhFile(queueDoc)"
          ></m-button>
        </p>
      </div>
    </v-alert>

    <m-card-list
      title="Verval Peserta"
      search
      id-key
      @filter="filter"
      refresh
      :variablePencarian="[
        { key: 'Nama', value: 'name' },
        { key: 'Surel', value: 'email' }
      ]"
      :unduh="isCan('kelas-unduh-peserta')"
      :disableUnduh="isUnduh"
      @unduh="unduh"
      @refresh="load"
      @setStatusVerval="statusVerval"
      filterStatus
      :items="items"
      footerLabel="Pengguna"
      @search="
        search => {
          dataPencarian = search;
          load();
        }
      "
      :page="page"
      @change:page="
        pg => {
          cp = pg;
          load();
        }
      "
      footer
    >
      <template v-slot:filter>
        <v-divider></v-divider>
      </template>
      <template v-slot:items="{ item }">
        <v-row class="mx-3">
          <v-col :cols="$vuetify.breakpoint.smAndUp ? 12 : 10" sm="9" md="9" lg="10" xl="10">
            <v-row>
              <v-col cols="12" sm="12" md="4" lg="3" xl="3">
                <p class="caption black--text my-0 py-0">Nama</p>
                <p class="body-1 font-weight-bold my-0 py-0">
                  {{ pVal(item, "name") }}
                </p>
                <p class="blue--text caption">{{ pVal(item, "email_belajar_id") }}</p>
              </v-col>
              <v-col cols="12" sm="12" md="2" lg="2" xl="2">
                <p class="caption grey--text my-0 py-0">Asal Sekolah</p>
                <p v-if="item.info_guru && item.info_guru.ptk">{{ item.info_guru.ptk.instansi }}</p>
              </v-col>
              <v-col cols="12" sm="12" md="2" lg="2" xl="2">
                <p class="caption grey--text my-0 py-0">Kota/Kabupaten</p>
                <p v-if="item.kelasenrol[0].kota_sekolah&&item.kelasenrol[0].kota_sekolah.provinsi">{{ item.kelasenrol[0].kota_sekolah.provinsi.keterangan }} - {{ item.kelasenrol[0].kota_sekolah.keterangan }}</p>
              </v-col>

              <v-col cols="12" sm="12" md="2" lg="2" xl="2">
                <p class="caption grey--text my-0 py-0">Tanggal Pengajuan</p>
                {{ item.kelasenrol[0].created_at | toDT }}
              </v-col>
              <v-col cols="12" sm="12" md="3" lg="3" xl="3">
                <p class="caption grey--text my-0 py-0">Status</p>
                <span :class="!item.kelasenrol[0].completed_by ? 'warning--text' : item.kelasenrol[0].is_complete == 1 ? 'success--text' : 'error--text'">{{
                  !item.kelasenrol[0].completed_by ? "Belum diverval" : item.kelasenrol[0].is_complete == 1 ? "Diterima" : "Ditolak"
                }}</span>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="1" sm="1" md="1" lg="1" xl="1">
            <p></p>
            <m-menu left style="float:right" :items="more_menu" :object="item" />
          </v-col>
        </v-row>
        <v-divider />
      </template>
    </m-card-list>
    <FormVerval ref="dlgVerval" />
  </div>
</template>

<script>
import { isCan } from "@/tools";
import FormVerval from "../components/DetailVerval.vue";
// import FilterPengguna from "@/filter/FilterPengguna.vue";

// @group Global Feature
export default {
  name: "kelas-peserta",
  components: {
    // FilterPengguna,
    FormVerval
  },
  data() {
    return {
      items: [],
      textSearch: null,
      dataPencarian: null,
      page: null,
      cp: 1,
      stat: {
        total_ajuan: null,
        belum_diverval: null,
        diterima: null,
        Ditolak: null
      },
      queueDoc: null,
      isUnduh: false,
      jumlahPengguna: 0,
      intervalId: null,
      more_menu: [
        {
          title: "Verifikasi Peserta",
          icon: "mdi-account-check",
          color: "green",
          click: (i, o) => this.openVerval(o),
          check: () => isCan("verval")
        }
      ]
    };
  },
  computed: {
    headers() {
      const a = [
        { text: "", align: "left", value: "" },
        { text: "", align: "left", value: "" },
        { text: "", align: "left", value: "" },
        { text: "", align: "left", value: "" },
        { text: "", sortable: false }
      ];
      return a;
    }
  },
  mounted() {
    this.loadStatistik();

  },
  beforeDestroy() {
    this.clearInterval(); // Clear the interval when the component is destroyed to prevent memory leaks
  },
  beforeRouteLeave(to, from, next) {
    this.clearInterval(); // Clear the interval when the route is changing
    next();
  },
  props: {
    enroll: {
      type: Boolean,
      default: false
    },
    is_kelas_tutup: {
      type: Boolean,
      default: false
    },
    is_daring: {
      type: Boolean,
      default: false
    },
    is_nilai: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    load() {
      var params = {
        page: this.cp,
        peran_kelas: this.peran,
        status_verval: this.statusVervalData
      };

      if (this.dataPencarian) {
        var param = this.dataPencarian.param.value;
        params[param] = this.dataPencarian.s;
      }

      return this.$store
        .dispatch("kelas/getPesertaKelas", {
          instansi_id: this.instansi_id,
          kelas_id: this.kelas_id,
          params: params
        })
        .then(res => {
          this.page = res;
          this.jumlahPengguna = res.total;
          this.items = res.data;
          this.loadJobs(); // Initial call to loadJobs
        })

        .catch(e => e);
    },

    startInterval() {
      this.intervalId = setInterval(this.loadJobs, 5000);
    },
    clearInterval() {
      if (this.intervalId) {
        clearInterval(this.intervalId);
        this.intervalId = null;
      }
    },

    loadJobs() {
      return this.$store
        .dispatch("kelas/getJobBerkas", { instansi_id: this.instansi_id, kelas_id: this.kelas_id, params: { tipe_dokumen: 1 } })
        .then(res => {
          this.queueDoc = res.length > 0 ? res[0] : null;

          // Cek apakah ada status 1, 2, 3 dalam res dan set isUnduh sesuai
          const hasStatus1 = res.some(job => job.status === 1);
          const hasStatus2 = res.some(job => job.status === 2);
          const hasStatus3 = res.some(job => job.status === 3);

          this.isUnduh = hasStatus1 || hasStatus2 || hasStatus3;

          // Jika queueDoc memiliki status 2, hentikan interval
          if (this.queueDoc && this.queueDoc.status === 2) {
            this.clearInterval();
          }
        })
        .catch(e => {
          throw e; // Rethrow the error to handle it further if needed
        });
    },

    loadStatistik() {
      return this.$store
        .dispatch("kelas/statistikVerval", {
          instansi_id: this.instansi_id,
          kelas_id: this.kelas_id
        })
        .then(res => {
          this.stat = res;
          this.load();
        })
        .catch(e => e);
    },

    unduh() {
      this.isUnduh = true;
      return this.$store
        .dispatch("kelas/unduhVerval", {
          instansi_id: this.instansi_id,
          kelas_id: this.kelas_id,
          tipe_dokumen: 1
        })
        .then(() => {
          this.$info("Unduhan dalam proses, tunggu beberapa saat");
          this.loadJobs();
          this.startInterval();
        })
        .catch(e => e);
    },

    unduhFile(val) {
      this.isUnduh = false;
      return this.$store
        .dispatch("kelas/setUnduh", {
          instansi_id: this.instansi_id,
          kelas_id: this.kelas_id,
          dokumen_unduh: val.id
        })
        .then(() => {
          this.loadJobs();
          window.open(val.url, "_blank");
        })
        .catch(e => e);
    },

    pencarian() {
      this.cp = 1;
      this.current_page = 1;
      this.load();
    },
    statusVerval(val) {
      if (val) {
        this.cp = 1;
        this.current_page = 1;
        this.statusVervalData = val;
        this.load();
      } else {
        this.statusVervalData = null;
        this.load();
      }
    },
    filter(data) {
      this.peran = data.peran;
      this.load();
    },
    openVerval(val) {
      this.$refs.dlgVerval.open(val).then(() => {
        this.load();
      });
    }
  }
};
</script>
